import { useState } from "react";
import { Sparkles, ChevronDown } from "lucide-react";
import { EVOLUTION_TEMPLATES } from "@/lib/evolutionTemplates";

/**
 * Quick picker for elaborated evolution templates.
 * Calls onPick({ diagnostico, procedimiento, observaciones }) so the parent
 * can merge into its form state.
 */
export default function EvolutionTemplatePicker({ onPick, compact = false }) {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState("");

  const filtered = q
    ? EVOLUTION_TEMPLATES.filter((t) => t.label.toLowerCase().includes(q.toLowerCase()))
    : EVOLUTION_TEMPLATES;

  const choose = (t) => {
    onPick({
      diagnostico: t.diagnostico,
      procedimiento: t.procedimiento,
      observaciones: t.observaciones,
    });
    setOpen(false);
    setQ("");
  };

  return (
    <div className="relative" data-testid="evolution-templates">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className={`inline-flex items-center gap-2 px-3 ${compact ? "h-8 text-[11px]" : "h-9 text-xs"} rounded-sm border border-primary/40 bg-primary/5 hover:bg-primary/10 text-primary font-bold uppercase tracking-widest`}
        data-testid="evolution-templates-toggle">
        <Sparkles className="w-3.5 h-3.5" />
        Plantillas
        <ChevronDown className={`w-3 h-3 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <>
          <div className="fixed inset-0 z-30" onClick={() => setOpen(false)} />
          <div className="absolute right-0 mt-1 z-40 w-80 max-h-96 overflow-y-auto bg-card border border-border rounded-sm shadow-lg">
            <div className="p-2 border-b border-border sticky top-0 bg-card">
              <input
                autoFocus
                value={q}
                onChange={(e) => setQ(e.target.value)}
                placeholder="Buscar plantilla…"
                className="input-flat h-9 text-sm"
                data-testid="evolution-templates-search"
              />
              <div className="text-[10px] text-muted-foreground mt-1.5 px-1">
                Insertar texto base · luego personalízalo
              </div>
            </div>
            {filtered.length === 0 ? (
              <div className="p-4 text-center text-xs text-muted-foreground">Sin coincidencias</div>
            ) : filtered.map((t) => (
              <button
                key={t.key}
                type="button"
                onClick={() => choose(t)}
                data-testid={`tpl-${t.key}`}
                className="w-full text-left px-3 py-2.5 border-b border-border last:border-b-0 hover:bg-primary/5">
                <div className="text-sm font-bold">{t.label}</div>
                <div className="text-[11px] text-muted-foreground line-clamp-2 mt-0.5">{t.procedimiento}</div>
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
